import { useMemo } from '~libs.ui.react';

import { getMedicineSufficiencyCount, MedicineSufficiencyOptions } from '../data/medicineSufficiency';

export type UseMedicineSufficiencyCountOptions = MedicineSufficiencyOptions & {
   packagesCount: number | null | undefined;
};

export const useMedicineSufficiencyCount = (options: UseMedicineSufficiencyCountOptions): number | undefined => {
   const { medicine, packagesCount } = options;
   const { frequency, portion, unit } = options.preciseDosage ?? {};

   const singlePackageCapacity = medicine?.singlePackageCapacity;
   const singlePackageUnit = medicine?.singlePackageUnit;
   const singlePackageQuantity = medicine?.singlePackageQuantity;

   return useMemo(
      () =>
         getMedicineSufficiencyCount({
            medicine: medicine,
            preciseDosage: { frequency: frequency, portion: portion, unit: unit },
            packagesCount: packagesCount,
         }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [singlePackageCapacity, singlePackageUnit, singlePackageQuantity, frequency, portion, unit, packagesCount]
   );
};
